import React from 'react';
import { Navigate } from "react-router-dom";

const Security = (props) => {
	if (!props.condition) return <Navigate to={props.redirectTo} />
	return props.children
}

export default Security;